module.exports = __webpack_public_path__ + "img/share_friends.772aadd4.png";